import React from "react";
import "./ModalPregunta.css";
import { TerminalQuestion } from "./Terminal";
import HotspotYesNo from "./HotspotYesNo";
import DragDrop from "./DragDrop";
import DragDropDivergent from "./DragDropDivergent";
import TextoConImagenes from "./TextoConImagenes";

function ModalPregunta({
  pregunta,
  numeroPregunta,
  respuestaUsuario,
  respuestaCorrecta,
  esCorrecta,
  sinResponder,
  onClose,
}) {
  if (!pregunta) return null;

  // Renderizar la pregunta según su tipo (solo lectura)
  const renderPregunta = () => {
    const tipoPregunta = pregunta.tipo_pregunta;

    switch (tipoPregunta) {
      case "hotspot":
        // Agrupar opciones por dropdown_id para hotspot
        const opcionesPorDropdown = {};
        pregunta.opciones?.forEach((opcion) => {
          if (opcion.dropdown_id) {
            if (!opcionesPorDropdown[opcion.dropdown_id]) {
              opcionesPorDropdown[opcion.dropdown_id] = [];
            }
            opcionesPorDropdown[opcion.dropdown_id].push(opcion);
          }
        });

        // Ordenar dropdowns por ID
        const dropdownIds = Object.keys(opcionesPorDropdown)
          .map((id) => parseInt(id))
          .sort((a, b) => a - b);

        return (
          <div className="modal-pregunta-contenido">
            <div className="modal-hotspot-container">
              {dropdownIds.map((dropdownId) => {
                const opciones = opcionesPorDropdown[dropdownId].sort(
                  (a, b) => a.orden - b.orden
                );
                const correctaId =
                  respuestaCorrecta?.[`dropdown_${dropdownId}`];
                const usuarioId = respuestaUsuario?.[`dropdown_${dropdownId}`];
                const opcionCorrecta = opciones.find(
                  (o) => o.id === correctaId
                );
                const opcionUsuario = opciones.find((o) => o.id === usuarioId);
                const esCorrecto = correctaId && usuarioId === correctaId;

                // Obtener el enunciado del dropdown
                const enunciado =
                  pregunta.dropdowns_enunciados &&
                  pregunta.dropdowns_enunciados[dropdownId]
                    ? pregunta.dropdowns_enunciados[dropdownId]
                    : `Dropdown ${dropdownId}:`;

                return (
                  <div
                    key={dropdownId}
                    className={`modal-dropdown-group ${
                      esCorrecto
                        ? "correcto"
                        : usuarioId
                        ? "incorrecto"
                        : "sin-responder"
                    }`}
                  >
                    <label className="modal-dropdown-label">{enunciado}</label>
                    <div className="modal-dropdown-wrapper">
                      <select className="modal-dropdown" disabled>
                        <option>
                          {sinResponder
                            ? "Not answered"
                            : opcionUsuario?.texto || "Not answered"}
                        </option>
                      </select>
                      <div
                        className={`modal-indicador ${
                          esCorrecto
                            ? "correcto"
                            : usuarioId
                            ? "incorrecto"
                            : "sin-responder"
                        }`}
                      >
                        {sinResponder ? "?" : esCorrecto ? "✓" : "✗"}
                      </div>
                    </div>
                    {opcionCorrecta && (
                      <div className="modal-respuesta-correcta">
                        Correct answer: <strong>{opcionCorrecta.texto}</strong>
                      </div>
                    )}
                    {opcionUsuario &&
                      opcionUsuario.id !== opcionCorrecta?.id && (
                        <div className="modal-respuesta-usuario">
                          Your answer: <strong>{opcionUsuario.texto}</strong>
                        </div>
                      )}
                  </div>
                );
              })}
            </div>
          </div>
        );

      case "hotspot_terminal":
      case "hotspot_yesno":
        // Para hotspot_terminal y hotspot_yesno, usar los componentes existentes pero en modo solo lectura
        // Agrupar opciones por dropdown_id
        const opcionesPorDropdown2 = {};
        pregunta.opciones?.forEach((opcion) => {
          if (opcion.dropdown_id) {
            if (!opcionesPorDropdown2[opcion.dropdown_id]) {
              opcionesPorDropdown2[opcion.dropdown_id] = [];
            }
            opcionesPorDropdown2[opcion.dropdown_id].push(opcion);
          }
        });

        if (tipoPregunta === "hotspot_terminal") {
          return (
            <div className="modal-pregunta-contenido">
              <TerminalQuestion
                pregunta={pregunta}
                opcionesPorDropdown={opcionesPorDropdown2}
                respuestas={{ [pregunta.id]: respuestaUsuario || {} }}
                onSelectDropdown={() => {}}
                disabled={true}
              />
              {/* Mostrar respuestas correctas e incorrectas */}
              {Object.keys(opcionesPorDropdown2).map((dropdownIdStr) => {
                const dropdownId = parseInt(dropdownIdStr);
                const correctaId =
                  respuestaCorrecta?.[`dropdown_${dropdownId}`];
                const usuarioId = respuestaUsuario?.[`dropdown_${dropdownId}`];
                const opciones = opcionesPorDropdown2[dropdownId];
                const opcionCorrecta = opciones.find(
                  (o) => o.id === correctaId
                );
                const opcionUsuario = opciones.find((o) => o.id === usuarioId);
                const esCorrecto = correctaId && usuarioId === correctaId;

                if (!opcionCorrecta) return null;

                return (
                  <div
                    key={dropdownId}
                    className="modal-respuesta-feedback"
                    style={{
                      marginTop: "1rem",
                      padding: "1rem",
                      background: esCorrecto ? "#d4edda" : "#f8d7da",
                      borderRadius: "8px",
                    }}
                  >
                    {opcionCorrecta && (
                      <div>
                        <strong>Correct answer: </strong>
                        {opcionCorrecta.texto}
                      </div>
                    )}
                    {opcionUsuario && !esCorrecto && (
                      <div style={{ marginTop: "0.5rem" }}>
                        <strong>Your answer: </strong>
                        {opcionUsuario.texto}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          );
        } else if (tipoPregunta === "hotspot_yesno") {
          return (
            <div className="modal-pregunta-contenido">
              <HotspotYesNo
                pregunta={pregunta}
                opcionesPorDropdown={opcionesPorDropdown2}
                respuestas={{ [pregunta.id]: respuestaUsuario || {} }}
                onSelectDropdown={() => {}}
                disabled={true}
              />
              {/* Mostrar respuestas correctas e incorrectas */}
              {Object.keys(opcionesPorDropdown2).map((dropdownIdStr) => {
                const dropdownId = parseInt(dropdownIdStr);
                const correctaId =
                  respuestaCorrecta?.[`dropdown_${dropdownId}`];
                const usuarioId = respuestaUsuario?.[`dropdown_${dropdownId}`];
                const opciones = opcionesPorDropdown2[dropdownId];
                const opcionCorrecta = opciones.find(
                  (o) => o.id === correctaId
                );
                const opcionUsuario = opciones.find((o) => o.id === usuarioId);
                const esCorrecto = correctaId && usuarioId === correctaId;

                if (!opcionCorrecta) return null;

                return (
                  <div
                    key={dropdownId}
                    className="modal-respuesta-feedback"
                    style={{
                      marginTop: "1rem",
                      padding: "1rem",
                      background: esCorrecto ? "#d4edda" : "#f8d7da",
                      borderRadius: "8px",
                    }}
                  >
                    {opcionCorrecta && (
                      <div>
                        <strong>Correct answer: </strong>
                        {opcionCorrecta.texto}
                      </div>
                    )}
                    {opcionUsuario && !esCorrecto && (
                      <div style={{ marginTop: "0.5rem" }}>
                        <strong>Your answer: </strong>
                        {opcionUsuario.texto}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          );
        }
        return null;

      case "drag_drop":
      case "dragdrop_divergent":
        const dragDropData = pregunta.drag_drop_data || {};
        const draggableItems = dragDropData.draggable_items || [];
        const dropZones =
          tipoPregunta === "drag_drop"
            ? (dragDropData.drop_zones || []).sort(
                (a, b) => (a.orden || 0) - (b.orden || 0)
              )
            : (dragDropData.drop_zones || []).sort(
                (a, b) => (a.orden || 0) - (b.orden || 0)
              );
        const dropZonesLayout = dragDropData.drop_zones_layout || {};

        return (
          <div className="modal-dragdrop-container">
            <div className="modal-dragdrop-source">
              <h4>
                {dragDropData.titulo_source_column ||
                  (tipoPregunta === "drag_drop" ? "Services" : "Values")}
              </h4>
              <div className="modal-draggable-items">
                {draggableItems.map((item) => (
                  <div key={item.id} className="modal-draggable-item">
                    {item.texto}
                  </div>
                ))}
              </div>
            </div>
            <div className="modal-dragdrop-target">
              <h4>Your Answer</h4>
              {dropZones.map((zone) => {
                const usuarioId = respuestaUsuario?.[`drop_zone_${zone.id}`];
                const correctaId = respuestaCorrecta?.[`drop_zone_${zone.id}`];
                const itemUsuario = draggableItems.find(
                  (i) => i.id === usuarioId
                );
                const itemCorrecta = draggableItems.find(
                  (i) => i.id === correctaId
                );
                const esCorrecto = correctaId && usuarioId === correctaId;

                return (
                  <div
                    key={zone.id}
                    className={`modal-dropzone ${
                      esCorrecto
                        ? "correcto"
                        : usuarioId
                        ? "incorrecto"
                        : "sin-responder"
                    }`}
                  >
                    {zone.etiqueta && <label>{zone.etiqueta}</label>}
                    <div className="modal-dropzone-content">
                      {itemUsuario ? (
                        <div
                          className={`modal-dropzone-item ${
                            esCorrecto ? "correcto" : "incorrecto"
                          }`}
                        >
                          {itemUsuario.texto}
                          <span className="modal-indicador-dropzone">
                            {esCorrecto ? "✓" : "✗"}
                          </span>
                        </div>
                      ) : (
                        <div className="modal-dropzone-empty">Not answered</div>
                      )}
                      {itemCorrecta && !esCorrecto && (
                        <div className="modal-respuesta-correcta-dropzone">
                          Correct: {itemCorrecta.texto}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );

      case "multiple_choice":
      default: {
        const idsUsuario = Array.isArray(respuestaUsuario)
          ? respuestaUsuario
          : respuestaUsuario != null ? [respuestaUsuario] : [];
        const esUsuarioOpcion = (id) => idsUsuario.includes(id);
        return (
          <div className="modal-opciones-list">
            {pregunta.opciones?.map((opcion) => {
              const esCorrectaOpcion = opcion.correcta;
              const esUsuarioOpcionSel = esUsuarioOpcion(opcion.id);
              const esCorrectaYUsuario = esCorrectaOpcion && esUsuarioOpcionSel;
              const esUsuarioPeroIncorrecta =
                esUsuarioOpcionSel && !esCorrectaOpcion;

              let claseOpcion = "modal-opcion-item";
              if (esCorrectaOpcion) claseOpcion += " modal-opcion-correcta";
              if (esUsuarioPeroIncorrecta)
                claseOpcion += " modal-opcion-incorrecta";

              return (
                <div key={opcion.id} className={claseOpcion}>
                  <div className="modal-opcion-circulo">
                    {esCorrectaOpcion && (
                      <span className="modal-circulo-indicador">✓</span>
                    )}
                    {esUsuarioPeroIncorrecta && (
                      <span className="modal-circulo-indicador-incorrecto">
                        ✗
                      </span>
                    )}
                  </div>
                  <div className="modal-opcion-texto">{opcion.texto}</div>
                  {esUsuarioOpcionSel && (
                    <span className="modal-opcion-badge">Your answer</span>
                  )}
                  {esCorrectaOpcion && !esUsuarioOpcionSel && (
                    <span className="modal-opcion-badge-correcta">
                      Correct answer
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        );
      }
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content modal-pregunta"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <span className="modal-pregunta-badge">Question {numeroPregunta}</span>
          <span
            className={`modal-estado-badge ${
              sinResponder
                ? "sin-responder"
                : esCorrecta
                ? "correcta"
                : "incorrecta"
            }`}
          >
            {sinResponder
              ? "Not answered"
              : esCorrecta
              ? "✓ Correct"
              : "✗ Incorrect"}
          </span>
          <button className="modal-close-btn" onClick={onClose} type="button" aria-label="Close">
            ×
          </button>
        </div>

        <div className="modal-body">
          <div className="modal-pregunta-texto">
            <TextoConImagenes
              texto={pregunta.texto}
              imagenes={pregunta.imagenes || []}
              tablasContenido={pregunta.tablas_contenido || []}
              basePath="/imagenes/"
            />
          </div>

          {renderPregunta()}
        </div>
      </div>
    </div>
  );
}

export default ModalPregunta;
